module.exports = __webpack_public_path__ + "img/monitor-waveform.d9af6ebf.svg";